import Service from '@/helpers/service'

export default {

    index(id_karyawan) {
        return Service().get('dokumen-karyawan/index', {params: {id_karyawan: id_karyawan}});
    },
    create(params) {
        return Service().post('dokumen-karyawan/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('dokumen-karyawan/delete/'+id);
    },
    // Authenticated download -- the route sits behind JWT middleware, so a
    // plain <a href> (no Authorization header) would just get an
    // unauthorized response. Fetched as a blob instead, same pattern as
    // MobileAttendanceReview's selfie download.
    download(id) {
        return Service().get('dokumen-karyawan/download/'+id, {responseType: 'blob'});
    },
}
